"use client";

import { ReactNode } from "react";
import { Slot } from "@radix-ui/react-slot";

import { cn } from "@/lib/utils";
import { useSlotHeaderDrop } from "../../../hooks/useBlockDnd";

/** Wraps a tab / step header (its single child) as a drop target: hovering it
 *  mid-drag opens that slot, dropping on it appends to the slot. */
export default function SlotHeaderDrop({
    children,
    ...target
}: {
    containerId: string;
    slotId: string;
    count: number;
    open: boolean;
    onOpen: () => void;
    children: ReactNode;
}) {
    const { setNodeRef, isOver } = useSlotHeaderDrop(target);
    return (
        <Slot
            ref={setNodeRef}
            className={cn(
                isOver &&
                    "outline outline-2 outline-[hsl(var(--platform-primary))]"
            )}
        >
            {children}
        </Slot>
    );
}
